import React               from 'react';
import { useParams }       from 'react-router';
import { Routes, Navigate }        from 'react-router-dom';
import OurTeamHeader       from 'pursuit/components/Widgets/OurTeamHeader';
import OurTeamProfilePhoto from 'pursuit/components/Widgets/OurTeamProfilePhoto';
import * as Members        from './Members';
import staff               from 'pursuit/config/staff';
import { getRoute }        from 'pursuit/routes/routes';

export default function OurTeamMember() {
    const params = useParams();
    const teamMember = params['*'];

    const staffer = staff[teamMember];
    const content = Members[teamMember];

    if (!staffer) {
        return <Navigate replace to={getRoute('ourTeam')} />
    }

    return (
        <section role="main" className="our-team--member">
            <div className="grid-center">
                <div className="col-4_xs-11">
                    <OurTeamProfilePhoto
                        profile={staffer.firstName}
                    />
                </div>
                <div className="col-7_xs-11">
                    <OurTeamHeader
                        fullName={staffer.fullName}
                        firstName={staffer.firstName}
                        letters={staffer.letters}
                        mainDiscipline={staffer.mainDiscipline}
                        bookingLink={staffer.bookingLink}
                        type={staffer.type}
                    />

                    {content()}
                </div>
            </div>
        </section>
    )
}
